import { Link } from "react-router-dom";
import type { Channel } from "@/mocks/gossip";
import { kindLabel } from "@/utils/format";

interface ChannelCardProps {
  channel: Channel;
}

export default function ChannelCard({ channel }: ChannelCardProps) {
  return (
    <Link
      to="/channels"
      className="group flex flex-col p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-400 transition-colors h-full cursor-pointer"
    >
      <div className="flex items-start justify-between gap-3">
        <span className="w-12 h-12 rounded-md flex items-center justify-center text-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
          <i className={channel.icon} />
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs bg-background-100 text-foreground-600 border border-background-300 whitespace-nowrap">
          {kindLabel(channel.kind)}
        </span>
      </div>
      <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
        {channel.name}
      </h3>
      <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{channel.intro}</p>
      <div className="mt-auto pt-4 flex items-center justify-between text-xs text-foreground-500 border-t border-background-200">
        <span className="flex items-center gap-1 pt-3"><i className="ri-archive-line" />{channel.count} 条内容</span>
        <span className="flex items-center gap-1 pt-3">
          {channel.hot && <i className="ri-fire-fill text-primary-500" />}
          {channel.update}
        </span>
      </div>
    </Link>
  );
}